import React from 'react';
import {ListGroup, ListGroupItem } from 'reactstrap';
import {appHelpers} from "../../_helpers";
import ToolTipItem from "../utils/tooltip";

const InvoiceResultsBreakdown = ({invoiceReconciliationFiles, searchByProcessName}) => {
    return (
        <div>
            <div>
                <h6 className="mb-2">Process Breakdown</h6>
                <ListGroup className={'process_breakdown_list'}>
                    {  invoiceReconciliationFiles.map((item, i) => {
                        return (<span className="text-avi-primary pointer card-link" key={i}>
                                <ListGroupItem onClick={() => searchByProcessName(item) } className="justify-content-between">
                                    { item.ProcessName }
                                    <small>
                                        <ToolTipItem key={`${item.Id}BreakDownDateSupplied`} title={ appHelpers.formatDate(item.DateSupplied)} content='Date Uploaded' id={ `${item.Id}BreakDownDateSupplied` }/>
                                    </small>
                                </ListGroupItem>
                            </span>)
                    })
                    }
                </ListGroup>
            </div>
        </div>
    )
}


export default InvoiceResultsBreakdown;



// WEBPACK FOOTER //
// ./src/views/invoice/result-breakdown.js